<template>
  <el-dialog
    :title="$t('Comn_feed_stock')"
    top="25vh"
    width="80%"
    class="feed-add-dialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @beforeClose="handleCloseDialog"
  >
    <el-row>
      <el-row style="margin-bottom:10px;">
        <er-date-picker
          :clearable="false"
          size="mini"
          type="date"
          v-model="dateOfPurchase"
          :picker-options="pickerOptions"
          value-format="dd-MM-yyyy"
        ></er-date-picker>
      </el-row>

      <el-row>
        <er-data-tables
          type="white-header-table"
          :table-data="tableDataArr"
          :el-table-props="tableProps"
          :columns="tableColumns"
          :actionColumn="false"
          layout="table"
          uniqueId="feed_Add_Dialog"
        >
          <template v-slot:feed_name="{ row }">
            <el-select
              size="mini"
              v-model="row.data.resource_id"
              :placeholder="$t('select_feed')"
            >
              <el-option
                v-for="(resource, resource_id) in getObjResources"
                :label="resource.name"
                :value="resource_id"
                :key="resource_id"
              ></el-option>
            </el-select>
          </template>
          <template v-slot:no_of_items="{ row }">
            <el-input-number
              size="mini"
              :controls="false"
              v-model="row.data.no_of_items"
              @change="handleChangeInNoOfUnits(row.data)"
              placeholder="0"
            ></el-input-number>
          </template>
          <template v-slot:per_item_size="{ row }">
            <el-select
              size="mini"
              :controls="false"
              value-key="size"
              v-model="row.data.per_item_size"
              @change="handleChangeInQuantity(row.data)"
              :placeholder="$t('Stock_enter_quantity')"
            >
              <el-option
                v-for="i in [
                  { name: '10 kg', size: 10, units: 'KG' },
                  { name: '20 kg', size: 20, units: 'KG' },
                  { name: '25 kg', size: 25, units: 'KG' }
                ]"
                :key="i.size"
                :value="i.size"
                :label="i.name"
              ></el-option>
            </el-select>
          </template>
          <template v-slot:total_price="{ row }">{{
            row.data.total_price | numberWith2DigitPrecision
          }}</template>
          <template v-slot:vendor_id="{ row }">
            <el-select
              v-model="row.data.vendor_id"
              size="mini"
              :placeholder="$t('Resource_select_vendors')"
            >
              <el-option
                v-for="(vendor, vendor_id) in getObjVendors"
                :label="vendor.name"
                :value="vendor_id"
                :key="vendor_id"
              ></el-option>
            </el-select>
          </template>
          <template v-slot:actions="{ row }">
            <template v-if="row.$index === tableDataLength - 1">
              <er-button
                icon="el-icon-plus"
                size="mini"
                @click="handleAddRow()"
                circle
              ></er-button>
            </template>
            <template v-else>
              <er-button
                icon="el-icon-minus"
                size="mini"
                circle
                @click="handleDeleteRow(row.$index)"
              ></er-button>
            </template>
          </template>
        </er-data-tables>
      </el-row>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-row type="flex">
        <el-col
          style="display:flex;align-items:flex-start;justify-content:flex-start"
        >
          <p class="footer__content">
            {{ $t("Stock_total_stock_abbr") }}
          </p>
        </el-col>
        <el-col>
          <er-button
            size="mini"
            btnType="save"
            :showLabel="true"
            :showIcon="true"
            @click="handleCloseDialog('close')"
            :loading="loading"
            disabled
          ></er-button>
          <er-button
            size="mini"
            btnType="cancel"
            :showLabel="true"
            @click="handleCloseDialog('close')"
            disabled
          ></er-button>
        </el-col>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Feed from "@/model/feed";
export default {
  props: {
    showDialog: {
      default: false
    }
  },

  data: function() {
    return {
      tableDataArr: [new Feed()],
      dateOfPurchase: ""
    };
  },
  created() {
    this.dateOfPurchase = this.$moment().format("DD-MM-YYYY");
  },
  filters: {
    numberWith2DigitPrecision(value) {
      if (!value) return 0;
      value = Number(value);
      return value.toFixed(2);
    }
  },
  computed: {
    ...mapGetters("resource", {
      getObjResources: "getObjResources",
      getObjVendors: "getObjVendors"
    }),
    pickerOptions() {
      return {
        disabledDate: function(time) {
          return time.getTime() > Date.now();
        }
      };
    },

    tableProps: function() {
      return {
        size: "small",
        defaultSort: {
          prop: "pond_title",
          order: "ascending"
        }
      };
    },
    tableDataLength: function() {
      return this.tableDataArr.length;
    },
    tableColumns() {
      return {
        feed_name: {
          prop: "feed_name",
          label: this.$t("Comn_feed_name"),
          minWidth: "90",
          align: "left"
        },
        no_of_items: {
          prop: "no_of_items",
          label: this.$t("Stock_no_of_bags"),
          minWidth: "100",
          align: "left"
        },
        per_item_size: {
          prop: "per_item_size",
          label: this.$t("Stock_bag_wgt"),
          minWidth: "100",
          align: "left"
        },
        total_price: {
          prop: "total_price",
          label: this.$t("Stock_purchased_total"),
          minWidth: "70",
          align: "left"
        },
        available_stock: {
          prop: "available_stock",
          label: this.$t("Stock_avail_stock"),
          minWidth: "70",
          align: "left"
        },
        total_stock: {
          prop: "total_stock",
          label: this.$t("Comn_total_stock"),
          minWidth: "70",
          align: "left"
        },
        vendor_id: {
          prop: "vendor_id",
          label: this.$t("Resource_vendor"),
          minWidth: "100",
          align: "left"
        },
        actions: {
          prop: "actions",
          label: this.$t("Comn_actions"),
          minWidth: "50",
          align: "left"
        }
      };
    },
    dialogVisible: {
      get() {
        return this.showDialog;
      },
      set(value) {
        this.handleCloseDialog("close");
      }
    }
  },
  methods: {
    handleCloseDialog(event) {
      this.$emit("close_dialog", event);
    },
    initDialogOnOpen() {
      this.tableDataArr = [new Feed()];
      this.dateOfPurchase = this.$moment().format("DD-MM-YYYY");
    },
    // handleClose() {
    //   this.changeDialogBoxVisibleStatus(false);
    // },
    handleAddRow() {
      this.tableDataArr.push(new Feed());
    },
    handleDeleteRow(rowIndexPos) {
      this.tableDataArr.splice(rowIndexPos, 1);
    },
    handleChangeInNoOfUnits(stockMedicineObj) {
      stockMedicineObj.total_price =
        stockMedicineObj.no_of_items * stockMedicineObj.per_item_size;
      stockMedicineObj.total_stock =
        stockMedicineObj.no_of_items + stockMedicineObj.available_stock;
    },
    handleChangeInQuantity(stockMedicineObj) {
      stockMedicineObj.total_price =
        stockMedicineObj.no_of_items * stockMedicineObj.per_item_size;
    }
  }
};
</script>

<style lang="scss">
.feed-add-dialog {
  .el-dialog__body {
    padding: 10px 20px;
  }

  .dialog-footer {
    .footer__content {
      opacity: 0.4;
      font-weight: bold;
      @include responsiveProperty(
        font-size,
        $app_font_size_small,
        $app_font_size_1,
        $app_font_size_2
      );
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 120px;
  }
}
</style>
